
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import ExchangeTabsComp from './views/Tabs/index.vue'
import ExchangeProductComp from './views/ExchangeProduct/index.vue'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'
import lodash from 'lodash'
import { EnumMyAccountPacksFilter, EnumMyAccountExchange } from '@xt/client/enums/my'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import ExchangeRecord from '../Record/index.vue'

@Observer
@Component({
  components: {
    ExchangeTabsComp,
    InfiniteLoading,
    ExchangeProductComp,
    EmptyStatus,
    ExchangeRecord
  }
})
export default class ExchangeList extends Vue {
  tabActiveKey: number = +lodash.get(this.$route.query, 'active', EnumMyAccountPacksFilter.All.toString())
  showRecord: boolean = false

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  get PageStore() {
    return this.$store.$myV2.Account.Exchange
  }

  get pagePagination() {
    return this.PageStore.ticketPagePagination
  }

  get body() {
    return {
      productType: `${this.tabActiveKey}00`
    }
  }

  onTabChange(active: number) {
    if (this.tabActiveKey === active) return

    this.showRecord = true
    this.tabActiveKey = active

    if (this.tabActiveKey !== EnumMyAccountExchange.Record) {
      this.showRecord = false
      this.pagePagination.clearData()
    }

    document.documentElement.scrollTo({ top: 0 })
  }

  created(): void {
    if (this.tabActiveKey === EnumMyAccountExchange.Record) {
      this.showRecord = true
    }
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
